import { render, staticRenderFns } from "./VariationImageSelector.vue?vue&type=template&id=d51c0ca6&"
import script from "./VariationImageSelector.vue?vue&type=script&lang=js&"
export * from "./VariationImageSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports